<ion-content class="no-scrollbar mobile-view-main" lang="en">
  <div class="opacity-layer"></div>
  <div class="mobile-view">
    <div class="height36">
      <div class="ion-text-center home-logo">
        <ion-img id="applogo" loading="lazy" alt="LottoSocial" src="../../assets/icon/lotto_social.svg"></ion-img>
      </div>

      @if (welcomePageData$ | async; as slider) {
      <div class="welcome-content" aria-label="welcomeSwiper">
        <swiper accesskey="s" (swiper)="setSwiperInstance($event)" [config]="swiperOpts" #welcomeSwiper
          (resize)="welcomeSwiper.update()">
          @for (slide of slider; track slide) {
          <ng-template swiperSlide class="content-slide">
            <h1 class="slide-title header" [innerHTML]="slide?._title?.[selectedLanguage || 'en'] || slide?.title"></h1>
            <p class="slide-text" [innerHTML]="slide?._description?.[selectedLanguage || 'en'] || slide?.description">
            </p>
          </ng-template>
          }
        </swiper>
      </div>
      }
    </div>

    <div class="height40">
      <div class="background-video-content">
        <video #bgVideo
        autoplay
        muted
        loop
        playsinline
        preload="auto">
        <source src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/public%2Fassets%2Fvideo%2Fbackground_video.webm?alt=media" type="video/webm">
        Your browser does not support the video tag.
      </video>
      </div>
    </div>

    <div class="bottom-flex-container">
      <div class="createacc-btn">
        <ion-button id="btnsignup" expand="block" class="action-btn-large account-btn"
          (click)="startSpinnerForCreateAcc()" routerDirection="forward">@if (!spinnerStartedForAcc) {
          <span>
            {{'welcome.account' | translate}}</span>
          }
          @if (spinnerStartedForAcc) {
          <ion-spinner name="crescent" duration="2000" mode="determinate" diameter="40" class="sign-up-spinner">
          </ion-spinner>
          }
        </ion-button>
      </div>

      <p id="btnlogin" class="alreadyhave-acc signin-text-light">
        {{'welcome.Already' | translate}}
        @if (!spinnerStarted) {
        <a class="signin" routerLink="/login" (click)="startSpinnerForSignIn($event)">{{'welcome.Sign in' |
          translate}}</a>
        }
        @if (spinnerStarted) {
        <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"></ion-spinner>
        }
      </p>
    </div>
  </div>
</ion-content>
